import React, { useCallback } from "react";
import { Btn, Container } from "./style";
//import { useAuth } from "../../../../../../hooks/auth";
import api from "../../../../../../services/api";
import { useToast } from "../../../../../../hooks/toast";

interface ButtonFieldProps {
  name: string,
  flow_base_id?: number;
  card_current_id?: number;
  id_field?: number;
  variation?: string
  placeholder?: string;
  formula?: string;
  isPublicForm?: boolean;
  public_hash?: string;
  onForceBlur?: () => void;
  onForceCardUpdate?: () => void;
}

/*
interface ButtonFieldValueProps {
  user_id: number;
  name_user: string;
  last_click: string;
}
*/

const ButtonFieldView: React.FC<ButtonFieldProps> = ({ name, variation, placeholder, formula, flow_base_id, card_current_id, id_field, isPublicForm, public_hash, onForceBlur, onForceCardUpdate }) => {

  //const { user } = useAuth();
  const { addToast } = useToast();

  //const [lastClick, setLastClick] = React.useState<ButtonFieldValueProps | undefined>();
  const [loading, setLoading] = React.useState(false);

  const handleClick = useCallback(async () => {

    const endpoint = isPublicForm ? `/form-public/automation/button` : `/automation/button`;

    //let lastClickValue: ButtonFieldValueProps;

    if (id_field !== undefined && card_current_id !== undefined && flow_base_id !== undefined) {

      setLoading(true);

      /*
      if (user !== undefined && user.id_user !== null) {
        lastClickValue = {
          user_id: user.id_user,
          name_user: user.name,
          last_click: new Date().toISOString(),
        };
        //setLastClick(lastClickValue);
      } else { // If is not logged in
        lastClickValue = {
          user_id: 2,
          name_user: "Formulário público",
          last_click: new Date().toISOString(),
        };
        //setLastClick(lastClickValue);
      }
      */

      await api.post(endpoint, {
        field_id: id_field,
        card_id: card_current_id,
        flow_id: flow_base_id,
        form_public_hash: public_hash,
      }).then(response => {
        if (response.data !== null) {

          const respData: boolean = response.data;

          if (respData) {
            onForceCardUpdate && onForceCardUpdate();
            addToast({
              type: 'success',
              title: 'Automação disparada com sucesso',
              description: 'A automação foi disparada com sucesso :)',
            });
          } else {
            addToast({
              type: 'error',
              title: 'Erro ao disparar a automação',
              description: 'Ocorreu um erro ao tentar disparar a automação! Verifique detalhes no histórico de execução.',
            });
          }
        }
        setLoading(false);
      }).catch(error => {
        setLoading(false);
        addToast({
          type: "error",
          title: "Erro ao disparar automação.",
          description: "Ocorreu um erro ao chamar a automação! Verifique sua conexão com a internet.",
        });
      });

    } else {
      addToast({
        type: "error",
        title: "Erro ao disparar automação.",
        description: "Não foi possível encontrar todos os dados necessários para disparar a automação.",
      });
    }

  }, [addToast, card_current_id, flow_base_id, id_field, onForceCardUpdate, isPublicForm, public_hash]);

  return (
    <Container>
      <Btn
        type="button"
        color={formula !== undefined && formula !== null && formula !== "" ? formula : undefined}
        isLoading={loading}
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          e.preventDefault();
          e.stopPropagation();
          if (onForceBlur) {
            onForceBlur();
          }
          handleClick();
        }}
      >
        {placeholder !== undefined && placeholder !== null && placeholder !== "" ? placeholder : "Botão"}
      </Btn>
    </Container>
  );

}

export default ButtonFieldView;